import { IStore } from '../../store';
import { TBFL2Actions } from './actions';
import { IAuthActions } from '../auth/actions';
import blf2HistoryMiddleware from './middlewares/history.middleware';
import createMiddleware from '../../_core/create-middleware';

const blf2BaseMiddleware = createMiddleware<
    IStore,
    TBFL2Actions | IAuthActions
>()
    .getMiddleware();

const bfl2Middlewares = [
    blf2BaseMiddleware,
    blf2HistoryMiddleware,
];

export default bfl2Middlewares;
